import {
  AccountBookOutlined,
  BankOutlined,
  BlockOutlined,
  BookOutlined,
  BuildOutlined,
  CalculatorOutlined,
  GroupOutlined,
  HomeOutlined,
  InboxOutlined,
  MailOutlined,
  UserOutlined,
  IdcardOutlined,
} from '@ant-design/icons'

export const routePaths = {
  private: {
    isins: '/isins',
    marketIndexes: '/market-indexes',
    rfqs: '/rfqs',
    root: '/',
    tenants: '/tenants',
    proposedTenants: '/proposed-tenants',
    trades: '/trades',
    users: '/users',
    kyc: '/kyc-customers',
    issuers: {
      all: '/issuers',
      bespokeEmails: '/issuers/bespoke-emails',
      bankingGroups: '/issuers/banking-groups',
      bespokeRatings: '/tenants/bespoke-rating',
    },
    compliance: {
      rules: '/compliances/rules',
      values: '/compliances/values',
    },
  },
}

export const menuItems = [
  { route: routePaths.private.proposedTenants, label: 'Onboarding', icon: HomeOutlined },
  { route: routePaths.private.rfqs, label: 'RFQs', icon: InboxOutlined },
  { route: routePaths.private.trades, label: 'Trades', icon: BankOutlined },
  { route: routePaths.private.isins, label: 'Isins', icon: BlockOutlined },
  { route: routePaths.private.tenants, label: 'Tenants', icon: HomeOutlined },
  { route: routePaths.private.users, label: 'Users', icon: UserOutlined },
  { route: routePaths.private.marketIndexes, label: 'Market Indexes', icon: CalculatorOutlined },
  { route: routePaths.private.kyc, label: 'KYC Customers', icon: IdcardOutlined },
]

export const issuerMenuItems = [
  { route: routePaths.private.issuers.all, label: 'Issuers', icon: BankOutlined },
  { route: routePaths.private.issuers.bankingGroups, label: 'Banking Group Ratings', icon: GroupOutlined },
  { route: routePaths.private.issuers.bespokeRatings, label: 'Bespoke Ratings', icon: BuildOutlined },
  { route: routePaths.private.issuers.bespokeEmails, label: 'Bespoke RFQ Emails', icon: MailOutlined },
]

export const complianceMenuItems = [
  { route: routePaths.private.compliance.rules, label: 'Compliance Rules', icon: BookOutlined },
  { route: routePaths.private.compliance.values, label: 'Compliance Values', icon: AccountBookOutlined },
]
